import { ISearchParams, IUser, ISearchQueryString } from 'interfaces/'
import { Key } from 'react'
import { dateService } from './date.service'

const fromTokenToIUser = (data: any): IUser | undefined => {
  if (!!data) {
    const dataObj = JSON.parse(data)
    const tipoProfilo = JSON.parse(dataObj['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']!)

    return {
      id: dataObj['Id']!,
      tipoProfilo,
      cognome: dataObj['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname'],
      nome: dataObj['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname'],
      email: dataObj['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
      telefono: dataObj['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/otherphone'],
    }
  }
}
const fromISearchParamstoIBESearchParams = (searchParams?: ISearchParams) => {
  if (!searchParams) return
  return {
    tipoProfilo: searchParams.profileTypeId,
    dataDal: searchParams.dateFrom,
    dataAl: searchParams.dateTo,
    codiceEvento: searchParams.eventCode,
    ospiti: searchParams.guestsPerRoom,
    citta: searchParams.cityId,
    limit: searchParams.limit,
    orderby: searchParams.orderby,
    offset: searchParams.offset,
  }
}

const toISearchQueryString = (
  profileTypeId?: Key,
  cityId?: Key,
  dateFrom?: Date,
  dateTo?: Date,
  codiceEvento?: string,
  rooms?: number[],
): ISearchQueryString => {
  return {
    p: profileTypeId,
    c: cityId,
    df: dateFrom && dateService.formatDateForQueryString(dateFrom),
    dt: dateTo && dateService.formatDateForQueryString(dateTo),
    ce: codiceEvento,
    r: rooms,
  }
}
export const transformerService = {
  fromTokenToIUser,
  fromISearchParamstoIBESearchParams,
  toISearchQueryString,
}
